import illustrationRetina from 'marketing-website/media/images/pages/developers/illustrationAPI@2x.png';
import docsTeam from 'marketing-website/media/images/pages/developers/apiTeam@2x.png';
import graphQL from 'marketing-website/media/images/pages/developers/graphQL@2x.png';
import workflowRetina from 'marketing-website/media/images/pages/developers/superchargeWorkflow@2x.png';
import confluenceRetina from 'marketing-website/media/images/pages/developers/confluence@2x.jpg';
import dropboxRetina from 'marketing-website/media/images/pages/developers/dropbox@2x.jpg';
import showcaseRetina from 'marketing-website/media/images/pages/developers/showcase@2x.png';
import botbotRetina from 'marketing-website/media/images/pages/developers/botbot@2x.png';

const assets = {
  illustration: {
    alt: 'Developer API',
    src: illustrationRetina,
  },
  team: {
    alt: 'Developer API Team',
    src: docsTeam,
  },
  graphQL: {
    alt: 'Develop API GraphQL',
    src: graphQL,
  },
  workflow: {
    alt: 'Supercharge your developer workflow',
    src: workflowRetina,
  },
  confluence: {
    alt: 'Showcase your app in our integrations directory',
    src: confluenceRetina,
    maxWidth: 255,
  },
  dropbox: {
    alt: 'Showcase your app in our integrations directory',
    src: dropboxRetina,
    maxWidth: 255,
  },
  showcase: {
    alt: 'Showcase your app in our integrations directory',
    src: showcaseRetina,
  },
  botbot: {
    alt: 'Slack Bot for creating and managing prototypes',
    src: botbotRetina,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/developers/assets.js